<template>
  <section class="w-50">
    <el-steps :active="1">
      <el-step title="Step 1" icon="el-icon-edit"></el-step>
      <el-step title="Step 2" icon="el-icon-upload"></el-step>
      <el-step title="Step 3" icon="el-icon-picture"></el-step>
    </el-steps>
  </section>
</template>

<script>
export default {
  name: 'FormSteps',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  mounted() {},
  updated() {},
  activated() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';
</style>
